<template>
  <div class="col-12 _col-xl-8 d-flex">
    <div class="card flex-grow-1">
      <h6 class="card-header">Hebergements par catégorie de chambre</h6>
      <div class="card-body position-relative">

        <BarHorizontalComponent
          bar-styles="height: 60px;"
          :data="datas"
          @click="itemOnClick"
        />
        <div class="small text-muted d-flex gap-3 flex-wrap">
          <div class="" v-for="(item, label) in roomByName" :key="label">{{ label }}: <b>{{ item.count }}</b></div>

          <div class="ms-auto">Total Chambres: <b>{{ roomCount }}</b></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import * as ChartHelper from '@/compositions/chartHelper';
  import { computed } from 'vue';
  import { useBoardFilters } from '@/compositions/useBoardFilters';
  import { countRooms } from '@/compositions/helper';

  // Ce widget ne s'intéresse qu'aux inscrits : il n'applique pas le filtre statut
  // (il filtre lui-même sur completionDate) mais applique le filtre organisateurs
  const { travel, participations, filters } = useBoardFilters({ applyStatus: false })

  const inscrits = computed(() => {
    return (participations.value.filter(x=>x.invitation?.completionDate != null && x.invitation?.refusalDate == null) ?? []);
  });

  const rooms = computed(() => {
    return inscrits.value.flatMap(x => x.hotelRooms ?? []) ?? [];
  });

  const roomCount = computed(() => {
    return countRooms(rooms.value);
  })

  const roomByType = computed(() => {
    const travelRooms = travel?.value?.hotels
      ?.flatMap(hotel => hotel.quotaGroups ?? [])
      .flatMap(quotaGroup => quotaGroup.rooms ?? []) ?? [];

    const roomsById = new Map<number, ParticipationDbHotelRoom[]>();
    for (const room of rooms.value) {
      const roomId = room.travelDbHotelRoomId;
      if (!roomsById.has(roomId)) {
        roomsById.set(roomId, []);
      }
      roomsById.get(roomId)?.push(room);
    }

    const roomCountById = new Map<number, number>();
    for (const [roomId, rooms] of roomsById.entries()) {
      roomCountById.set(roomId, countRooms(rooms));
    }

    const result: Record<string, { label: string, count: number }> = {};
    const seenRoomIds = new Set<number>();

    for (const room of travelRooms) {
      if (seenRoomIds.has(room.id)) {
        continue;
      };

      seenRoomIds.add(room.id);
      result[room.id] = {
        label: room.name ?? `Room ${room.id}`,
        count: roomCountById.get(room.id) ?? 0
      };
    }

    return result;
  });

  const roomByName = computed(() => {
    // Group roomByType by label
    const result: Record<string, { count: number }> = {};
    Object.values(roomByType.value).forEach(room => {
      if (result[room.label]) {
        result[room.label].count += room.count;
      } else {
        result[room.label] = { count: room.count };
      }
    });

    // const grouped = users.reduce((acc, user) => {
    //   (acc[user.country] ??= []).push(user);
    //   return acc;
    // }, {});

    return result;
  });

  const datas = computed(() => {
    return {
      labels: ["Participants"],
      datasets: roomByName.value ? Object.keys(roomByName.value).map((optionId, index) => {
        return {
          label: optionId,
          data: [roomByName.value[optionId].count],
          backgroundColor: [ChartHelper.Colors[index % ChartHelper.Colors.length]],
          borderColor: [ChartHelper.Borders[index % ChartHelper.Borders.length]],
        }
      }) : []
    }
  });

  const itemOnClick = (label: string | undefined, value: number | [number, number] | undefined | null, index: number) => {
    if(filters && datas.value.datasets[index]?.label) {
      const roomLabel = datas.value.datasets[index].label;
      if (roomLabel) {
        filters.value.hotelRoomByName = { label: roomLabel };
      }
    }
  };
</script>
